import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { PropType } from "vue";
import {
  IArrivalTimeOption,
  IBus,
  IBusLocation,
} from "@/domain/entities/lineInfo";
import { IBusStop } from "@/domain/entities/busStop";
import BusStopRow from "@/components/line/BusStopRow.vue";
import { computed } from "@vue/reactivity";
import {
  ArrivalTimeOptionCode,
  ArrivalTimeOptionCodeType,
  BusStopEventCode,
} from "@/types";
import { IArrivalTime } from "@/domain/entities/lineInfo/arrivalTime.types";


const __default__ = {
  name: "BusStopList",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  selectedArrivalTimeOption: {
    type: Object as PropType<IArrivalTimeOption>,
  },
  busStops: {
    type: Array as PropType<IBusStop[]>,
    required: true,
  },
  selectedBus: {
    type: Object as PropType<IBusLocation>,
  },
  allBusesMap: {
    type: Object as PropType<Map<string, IBus>>,
  },
  busLocations: {
    type: Array as PropType<IBusLocation[]>,
  },
  arrivalTimeOptionCode: {
    type: String as PropType<ArrivalTimeOptionCodeType>,
  },
  selectComplete: {
    type: Boolean,
  },
  boardingBusStop: {
    type: Object as PropType<IBusStop>,
  },
  arrivalBusStop: {
    type: Object as PropType<IBusStop>,
  },
  showInMainCard: {
    type: Boolean,
    default: false,
  },
  shouldShowGetOffBell: {
    type: Boolean,
    default: false,
  },
  isInsideShuttle: {
    type: Boolean,
    default: false,
  },
  isBackwardLine: {
    type: Boolean,
    default: false,
  },
  lineId: {
    type: String,
    required: true,
  },
  turnId: {
    type: String,
    required: true,
  },
  isBookable: {
    type: Boolean,
  },
  isOnBoarding: {
    type: Boolean,
    default: false,
  },
  requestGetOffBusStopId: {
    type: String,
    default: "",
  },
  arrivalTimesForDisplay: {
    type: Array as PropType<IArrivalTime[]>,
    default: () => [],
  },
  favoriteGetOnBusStop: {
    type: Object as PropType<IBusStop>,
  },
  favoriteGetOffBusStop: {
    type: Object as PropType<IBusStop>,
  },
  detourEndDtm: {
    type: String,
  },
  shouldShowBusLocations: {
    type: Boolean,
    default: true,
  },
  shouldShowBusStopLocation: {
    type: Boolean,
    default: false,
  },
},
  emits: ["toggleSelectBusStop", "onClickBusStopLocation", "onClickScheduleBtn", "onClickGetOffBell", "onClickBubble", "onClickBusIcon", "onClickFavoriteStatusButton"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

_useCssVars(_ctx => ({
  "3b701e35-busLocationLeftMarginPx": (_unref(busLocationLeftMarginPx))
}))

const props = __props;

const emit = __emit;

const emitOnClickFavoriteStatusButton = (busStop: IBusStop) => {
  emit("onClickFavoriteStatusButton", busStop);
};

const emitOnClickBusIcon = (busesImageExisted: IBus[]) => {
  emit("onClickBusIcon", busesImageExisted);
};

const isInGarage = computed(() => {
  if (!props.busLocations?.length) {
    return false;
  }
  const busInGrarage = props.busLocations.filter((busLocation) => {
    if (!busLocation.busStopEvents.length) {
      return false;
    }
    return busLocation.busStopEvents.every(
      (busStopEvent) => busStopEvent.busStopEventCode === BusStopEventCode.None
    );
  });
  return !!busInGrarage.length;
});

const arrangedBusStops = computed(() => {
  if (!props.busStops?.length) return [];
  if (!props.isInsideShuttle) return props.busStops;
  /**
   * 셔틀인경우 기획된 UI에 따라 다음과 같이 표기 해야 함
   * ["수내", "GRC", "수내", "GRC"] => ["수내", "GRC", "수내"]
   */
  const firstBusStop = props.busStops[0];
  const busStops: IBusStop[] = [];
  for (const busStop of props.busStops.slice(1)) {
    busStops.push(busStop);
    if (busStop.id === firstBusStop.id) break;
  }
  busStops.unshift(firstBusStop);
  return busStops;
});

const busStopArrivalTimes = computed(() => {
  if (props.arrivalTimeOptionCode === ArrivalTimeOptionCode.AVG) {
    return props.busStops.map((busStop) => busStop.arrivalTime);
  }
  return props.busStops.map((busStop) => busStop.arrivalTime);
});

const emitOnClickGetOffBell = (busStopId: string, activate: boolean) => {
  emit("onClickGetOffBell", busStopId, activate);
};

const busLocationLeftMarginPx = props.showInMainCard ? "16px" : "25px";

const __returned__ = { props, emit, emitOnClickFavoriteStatusButton, emitOnClickBusIcon, isInGarage, arrangedBusStops, busStopArrivalTimes, emitOnClickGetOffBell, busLocationLeftMarginPx, BusStopRow }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})